<template>
    <div class="shopping-cart-coupon-row">
        <div class="cart-coupon-code-trigger">
            <label class="cart-coupon-trigger-label">
                {{ resources.showFieldLabel }}
            </label>
            <button v-if="!couponCodeValue" type="button" :class="['cart-coupon-trigger-btn', {'no-icon': showForm}]" @click="toggleForm">
                {{ showCTA }}
            </button>
            <button v-if="couponCodeValue" type="button" class="cart-coupon-trigger-btn no-icon" @click="deleteCoupon">
                {{ resources.removeCodeCTA }}
            </button>
        </div>
        <div v-if="showForm && !couponApplied" class="cart-coupon-code">
            <form class="rituals-form" novalidate="novalidate" @submit.prevent="addCoupon">
                <fieldset>
                    <div :class="['coupon-wrapper', {'has-error': showError}]">
                        <div class="coupon-input">
                            <div class="coupon-input-field">
                                <label class="cart-coupon-trigger-label">
                                    {{ resources.couponInputLabel }}
                                </label>
                                <input type="text" class="inputfield-text" :placeholder="resources.couponCodePlaceholder" maxlength="255" size="28" v-model="couponCode" />
                                <span v-if="showError" class="input-field-error">
                                    {{ errorMessage }}
                                </span>
                            </div>
                        </div>
                        <div class="coupon-btn">
                            <button class="btn">
                                <div :class="['spinner', 'white-spinner', {'spinner-visible': showSpinner}]">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>

                                <template v-if="!showSpinner">
                                    {{ resources.applyCTA }}
                                </template>
                            </button>
                        </div>
                    </div>
                </fieldset>
            </form>
        </div>
        <div v-if="couponApplied" class="applied-coupon-row">
            <span> {{ couponCodeValue }}</span>
            <span v-if="!priceAdjustment">{{ resources.notAppliedInfo }}</span>
        </div>
    </div>
</template>

<script src='./coupon-form.js'></script>
